<template>
  <app-section theme="nude" class="v2-report">
    <div class="row">
      <report-form />
    </div>
  </app-section>
</template>

<script setup lang="ts">
import AppSection from "@/components/v2/section/index.vue";
import ReportForm from "@/components/report-form/index.vue";

defineOptions({
  name: "report-v2",
});
</script>

<style lang="scss">
@import "./index";
</style>
